// @ts-nocheck

import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Alert, Typography, Button as AntButton } from 'antd';
import '../../atoms/modal/modal.scss';
import { UploadFile } from 'antd/lib/upload/interface';
import StackItem from 'molecules/stackItem/stackItem';
import FileUploader from 'molecules/fileUploader';
import ModalBody from 'atoms/modal/modalBody';
import Stack from 'molecules/stack/stack';
import { getTableSelection } from 'models/dynamicGrid/selector';
import ModalHeader from 'atoms/modal/modalHeader';
import { toggleLoaderState } from 'models/loaders/reducer';
import { PAGES, UPLOAD_DATA_CHANGE_TYPES, UPLOAD_TYPE } from './constants';
import * as sagaActions from './sagaActions';
import Dropdown from 'atoms/dropdown/dropdown';
import Heading from 'atoms/heading/heading';
import ModalActions from 'atoms/modal/modalActions';
import Button from 'atoms/button/button';
import { useDispatch, useSelector } from 'react-redux';
import { onUploadFileV2, revalidateUploadGrid, submitUploadFile, triggerFetchDownloadTemplate } from './sagaActions';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import { getActivePage } from './selectors';
import * as selectors from './selectors';
import { setActivePage } from './reducer';
import { isLoadingEnabled, isRequestComplete, isRequestPending } from 'models/loaders/selectors';
import Loader from 'atoms/loader';
import BodyText from 'atoms/bodyText/bodyText';
import ReactModal from 'atoms/modal/reactModal';
import { getComponentUserSettings, getERPStatus, getGridData, getGridMetadata } from 'models/dynamicGrid/selector';
import { fetchComponentUserSettings, handleBulkRowDelete } from 'models/dynamicGrid/sagaActions';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import Label from 'atoms/label/label';
import { REQUEST_STATUS } from 'models/loaders/constants';
import './upload.scss';
import * as constants from './constants';
import { getColumnInfoByIndentifier } from 'models/tableColumns/selector';
import { getState } from 'reducers';
import { useColumnAliasName } from 'hooks/useColumnAliasName';

const { Title } = Typography;
const getUploadContent = (rules) => {
	return (
		<ul>
			{rules?.map((r) => (
				<li>{<Label size="tiny">{r}</Label>}</li>
			))}
		</ul>
	);
};
interface Props {
	visible: boolean;
	onCancel: () => void;
	onUpload: ({ file, params }: { files: UploadFile; params: any }) => void;
}

const GridCsvUploadModal: React.FC<Props> = ({
	visible,
	onCancel,
	hasDataChangeType = true,
	title,
	onUpload,
	onUploadComplete = _.noop,
	parentTableId,
	uploadTableId,
	uploadParams,
	tableOptions,
	onClose,
	fieldGroups,
	height,
	isAvailability,
}) => {
	const [fileList, setFileList] = useState<UploadFile[]>([]);
	const dispatch = useDispatch();
	const isUploading = useSelector((state) => isLoadingEnabled(state, `upload`));
	const getColumnAliasName = useColumnAliasName(constants.UPLOAD_MODEL_ID);
	// const isSubmitting = useSelector((state) => isLoadingEnabled(state, `${uploadTableId} - submit`));
	const userSettings = useSelector((state) => getComponentUserSettings(state, 'file-upload'));
	const isLoadingUserSettings = useSelector((state) => isLoadingEnabled(state, `file-upload/${parentTableId}`));
	const gridRows = useSelector((state) => getGridData(state, uploadTableId));
	// const [customers, setCustomers] = React.useState([]);
	// const [warehouses, setWarehouses] = React.useState([]);
	const [isSubmitting, setIsSubmitting] = React.useState(false);
	const [importType, updateImportType] = useState('csv');
	const stagingParams = uploadParams ?? {
		...REQUESTS.PUT.GRID_UPLOAD_STAGING,
		submitService: REQUESTS.PUT.GRID_UPLOAD_SUBMIT.service,
		submitUrl: REQUESTS.PUT.GRID_UPLOAD_SUBMIT.url,
		tableId: uploadTableId,
	};
	const uploadMetaData = useSelector((state) => selectors.getUploadMetadata(state, parentTableId));

	const gridMetaData = useSelector((state) => getGridMetadata(state, uploadTableId));
	const [selectedCustomer, setSelectedCustomer] = React.useState({});
	const [selectedWarehouse, setSelectedWarehouse] = React.useState({});
	const isLoadingErp = useSelector((state) => isLoadingEnabled(state, 'isLoadingErp'));
	const isErpEnabled = useSelector((state) => getERPStatus(state, parentTableId)) || false;

	const customers = useSelector((state) => selectors.fetchCustomers(state)) || [];

	const warehouses = useSelector((state) => selectors.fetchWarehouses(state)) || [];

	const [isIncrementalUpload, handleIsIncrementalUpload] = React.useState({
		displayName: UPLOAD_DATA_CHANGE_TYPES[1].displayName,
		value: UPLOAD_DATA_CHANGE_TYPES[1].value,
	});

	const isUploadComplete = useSelector((state) => isRequestComplete(state, 'upload'));
	const selectedRowKeys: any = useSelector((state) => getTableSelection(state, uploadTableId));

	const uploadRulesTemplate = getUploadContent(uploadMetaData?.Rules);

	React.useEffect(() => {
		if (isErpEnabled && userSettings?.importType === 'erp') {
			updateImportType(UPLOAD_TYPE.ERP);
		}
		if (isLoadingUserSettings) {
			return;
		}
		// setCustomers(fetchedCustomers);
		// setWarehouses(fetchedWarehouses);

		setSelectedWarehouse(warehouses.find(({ value }) => value === userSettings?.warehouse) || warehouses[0]);
		setSelectedCustomer(customers.find(({ value }) => value === userSettings?.customer) || customers[0]);

		updateImportType(userSettings?.importType || 'csv');
		handleIsIncrementalUpload(
			UPLOAD_DATA_CHANGE_TYPES.find(({ value }) => value === userSettings?.isIncrementalUpload) ||
				UPLOAD_DATA_CHANGE_TYPES[1]
		);
	}, [isErpEnabled, userSettings, isLoadingUserSettings]);

	React.useEffect(() => {
		if (isUploadComplete) {
			setGridUpload(false);

			onUploadComplete();
			setIsSubmitting(false);
		}
		return () => {
			dispatch(
				toggleLoaderState({
					component: 'upload',
					status: REQUEST_STATUS.NONE,
				})
			);
			dispatch(setActivePage({ activePage: PAGES.UPLOAD }));
		};
	}, [dispatch, isUploadComplete, onUploadComplete]);

	const activePage = useSelector(getActivePage);
	const handleFileUpload = (fileList: UploadFile[]) => {
		setFileList(fileList);
	};
	const handleDownloadTemplate = () => {
		dispatch(
			triggerFetchDownloadTemplate({
				tableId: uploadTableId,
			})
		);
	};
	const handleUpload = () => {
		let params = {
			isIncrementalUpload: isIncrementalUpload?.value,
			importType,
			parentTableId,
			file: fileList?.[0],
		};

		if (isAvailability && importType === UPLOAD_TYPE.ERP) {
			params['warehouse'] = selectedWarehouse.value;
			params['customer'] = selectedCustomer.value;
		}

		if (onUpload) {
			onUpload({
				files: fileList,
				params: {
					isIncrementalUpload: isIncrementalUpload?.value,
					importType,
					parentTableId,
				},
			});
		}

		dispatch(
			onUploadFileV2({
				tableId: uploadTableId,
				params,
				uploadParams: stagingParams,
			})
		);
	};

	const handleSubmit = () => {
		if (onUpload) {
			onUpload({
				files: fileList,
				params: {
					isIncrementalUpload: isIncrementalUpload?.value,
				},
			});
		}
		setIsSubmitting(true);
		dispatch(
			submitUploadFile({
				tableId: uploadTableId,
				fieldGroups,
				parentTableId,
				uploadParams: stagingParams,
				isIncrementalUpload: isIncrementalUpload?.value,
			})
		);
	};
	const isDeleteEnabled =
		(selectedRowKeys?.isSelectAll && selectedRowKeys?.selectedRowKeys?.length) ||
		selectedRowKeys?.selectedRowKeys?.length;
	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		enableMultiSort: true,
		isUploadGrid: true,
		parentTableId,
		gridActions: true,
		selectionCallBack: () => {},
	};

	const reValidate = () => {
		dispatch(
			revalidateUploadGrid({
				tableId: uploadTableId,
				isIncrementalUpload: isIncrementalUpload?.value,
			})
		);
	};

	React.useEffect(() => {
		dispatch(sagaActions.resetUpload());
		if (isAvailability) {
			dispatch(sagaActions.getWarehouses());
			dispatch(sagaActions.getCustomers());
		}
		dispatch(
			fetchComponentUserSettings({
				tableId: parentTableId,
				component: 'file-upload',
			})
		);
		return () => {
			dispatch(sagaActions.resetUpload());
		};
	}, []);

	const templateConfig = React.useMemo(
		() => ({
			gridConfig,
			isFilterEnabled: true,
			tableId: uploadTableId,

			dataProviderOptions: {
				type: 'POST',
				version: 2,
				...REQUESTS.POST.GET_GRID_UPLOAD_DETAILS,
				body: {},
				multiSelectFieldGroups: {
					isTemplateRequired: true,
				},
				pathParams: { tableId: uploadTableId },
				...tableOptions?.dataProviderOptions,
			},

			selectRowKey: 'RowID',
		}),
		[uploadTableId]
	);
	const [isGridUpload, setGridUpload] = useState(false);

	useEffect(() => {
		if (!isGridUpload) {
			setFileList(null);
			dispatch(setActivePage({ activePage: PAGES.UPLOAD }));
		}
	}, [dispatch, isGridUpload]);

	const onDeleteAll = () => {
		dispatch(handleBulkRowDelete({ tableId: uploadTableId, isUploadGrid: true }));
	};

	return (
		<ReactModal
			height={height || (activePage === PAGES.UPLOAD && importType !== 'erp' ? 550 : 650)}
			width={activePage === PAGES.UPLOAD ? 600 : 800}
		>
			<ModalHeader>
				{' '}
				<Stack>
					<StackItem>{title ?? 'File Upload'}</StackItem>
					<StackItem></StackItem>
				</Stack>
			</ModalHeader>
			<ModalBody>
				{!isLoadingErp && activePage === PAGES.UPLOAD_GRID && (
					<Stack isVertical gutter="small">
						<>
							{' '}
							{Boolean(gridRows?.[0]?.ErrorCount) && (
								<StackItem isStretch>
									<Alert
										type="error"
										banner
										message="There are errors in the uploaded data, please re-upload or contact administrator for more info."
									></Alert>
								</StackItem>
							)}
							<StackItem isStretch align="right">
								<Stack gutter="small">
									<StackItem isGrow>
										{!gridMetaData?.isPristine && (
											<Alert
												type="warning"
												banner
												message="You have made changes that have not been validated, Please revalidate to continue."
											></Alert>
										)}
									</StackItem>
									<StackItem>
										<Button
											isText
											handleClick={() => {
												reValidate();
											}}
										>
											Revalidate
										</Button>
									</StackItem>
									<StackItem isStretch align="right">
										<Button isPrimary disabled={!isDeleteEnabled} handleClick={onDeleteAll}>
											Delete Selection
										</Button>
									</StackItem>
								</Stack>
							</StackItem>
						</>

						<StackItem isGrow>
							<ThetaGridPaginated isStorageEnabled={false} key={uploadTableId} config={templateConfig} />
						</StackItem>
					</Stack>
				)}

				{!isLoadingErp && activePage === PAGES.UPLOAD && (
					<Stack isVertical gutter="small">
						{isUploading ? (
							<>
								<StackItem isStretch align="center">
									<Loader></Loader>
								</StackItem>
								<StackItem isStretch align="center">
									<BodyText>Please wait while we upload your file.</BodyText>
								</StackItem>
							</>
						) : (
							<div className="raupload-wrapper">
								{' '}
								<Title level={5}>Upload Method: </Title>{' '}
								<div className="raupload-block csv-upload">
									<div className="btn-group">
										<button
											className={`btns btn-lt ra-buttons ${importType === 'csv' ? 'active' : ''}`}
											onClick={() => updateImportType('csv')}
										>
											<i className="icon-export" />
											CSV
										</button>

										<button
											className={`btns btn-rt ra-buttons ${importType === 'erp' ? 'active' : ''}`}
											onClick={() => updateImportType('erp')}
											disabled={!isErpEnabled}
										>
											<i className="icon-export" />
											ERP
										</button>
									</div>

									<div className="template-wrapper">
										<div className="template-block ra-buttons active">
											<Button type="primary" size="small" handleClick={handleDownloadTemplate}>
												<i className="icon-pin-page" /> Download Template
											</Button>
										</div>
									</div>

									<FileUploader
										disabled={importType === 'erp'}
										onUpload={handleFileUpload}
									></FileUploader>

									{isAvailability && importType === UPLOAD_TYPE.ERP && (
										<StackItem className="w-100">
											<Stack isStretch isVertical className="ant-form-group flex-wrap">
												<StackItem className="p-0 m-0">
													<Label>{getColumnAliasName('Customer')}</Label>
												</StackItem>
												<StackItem>
													<Dropdown
														selectedOption={selectedCustomer}
														updateHandler={setSelectedCustomer}
														options={customers}
													></Dropdown>
												</StackItem>
											</Stack>
										</StackItem>
									)}
									{isAvailability && importType === UPLOAD_TYPE.ERP && (
										<StackItem className="w-100">
											<Stack isStretch isVertical className="ant-form-group flex-wrap">
												<StackItem>
													<Label>{getColumnAliasName('Warehouses')}</Label>
												</StackItem>
												<StackItem>
													<Dropdown
														selectedOption={selectedWarehouse}
														updateHandler={setSelectedWarehouse}
														options={warehouses}
													></Dropdown>
												</StackItem>
											</Stack>
										</StackItem>
									)}
									{hasDataChangeType && (
										<StackItem className="w-100">
											<Stack isStretch isVertical className="ant-form-group flex-wrap">
												<StackItem className="p-0 m-0">
													<Label> Select Data Change Type</Label>
												</StackItem>
												<StackItem>
													<Dropdown
														selectedOption={isIncrementalUpload}
														updateHandler={handleIsIncrementalUpload}
														options={UPLOAD_DATA_CHANGE_TYPES}
														isFullWidth
													></Dropdown>
												</StackItem>
											</Stack>
										</StackItem>
									)}
								</div>
							</div>
						)}
					</Stack>
				)}
			</ModalBody>
			<ModalActions>
				<Stack gutter="small" align="center">
					<StackItem>
						<AntButton onClick={() => onClose(false)}>Cancel</AntButton>
					</StackItem>
					{activePage === PAGES.UPLOAD ? (
						<StackItem>
							<AntButton
								type="primary"
								isPrimary
								disabled={!fileList?.length && importType !== 'erp'}
								onClick={handleUpload}
							>
								Upload
							</AntButton>
						</StackItem>
					) : (
						<StackItem>
							<AntButton
								type="primary"
								loading={isSubmitting}
								disabled={!gridRows?.length || gridRows?.[0]?.ErrorCount || !gridMetaData?.isPristine}
								onClick={handleSubmit}
							>
								Submit
							</AntButton>
						</StackItem>
					)}
				</Stack>
			</ModalActions>
		</ReactModal>
	);
};

export default GridCsvUploadModal;
